import { Colors } from "../consts/Colors";
import AnswerFeedBack from "./AnswerFeedBack";

export default class ImageSlider extends Phaser.GameObjects.Container {
  constructor(scene, x, y, textureKeys, spacing = 750) {
    super(scene, x, y);

    this.currentIndex = 1;
    this.goodIndicesIndex = 0;
    this.slides = [];
    this.spacing = spacing;
    this.baseScale = 0.7;
    this.upperScale = 1.2;

    const imageWidth = 480; // même que ton cadre
    this.goodIndices = [2, 4, 1]; // ✅ à placer AVANT l'utilisation de includes

    textureKeys.forEach((key, index) => {
      const container = scene.add.container(0, 0);
      const frame = scene.add
        .rexRoundRectangle(0, 0, imageWidth, imageWidth, 14, Colors.Elmt.White)
        .setOrigin(0.5);

      // Cadre de feedback
      const feedbackFrame = scene.add
        .rexRoundRectangle(
          0,
          0,
          frame.width,
          frame.height,
          14,
          Colors.Elmt.White
        )
        .setOrigin(0.5)
        .setVisible(false)
        .setAlpha(0); // ← invisible par défaut

      const image = scene.add
        .image(0, 0, key)
        .setOrigin(0.5)
        .setInteractive({ cursor: "pointer" })
        .setDepth(10);
      frame.setSize(image.width + 20, image.height + 20);
      feedbackFrame.setSize(image.width + 20, image.height + 20);

      /*   const imageReponse = scene.add
        .image(0, 0, this.scene.missionData.bonneReponseImage)
        .setOrigin(0.5)
        .setDepth(10)
        .setScale(0)
        .setAlpha(0); */

      const imageReponse = this.scene.add
        .existing(
          new AnswerFeedBack(
            this.scene,
            0,
            0,
            "bonne-rep-activite-1",
            this.scene.getText("Mission2", "bonneReponse")
          )
        )
        .setScale(0)
        .setAlpha(0)
        .setDepth(10);

      const tagReponseImage = scene.add
        .image(-230, -140, "icone_check")
        .setOrigin(0.5)
        .setDepth(10)

        .setAlpha(0);

      container.add([
        frame,
        feedbackFrame,
        image,
        imageReponse,
        tagReponseImage,
      ]);
      this.add(container);
      this.slides.push(container);

      let answered = false;

      image.on("pointerdown", () => {
        if (index !== this.currentIndex) return; // Autoriser le clic uniquement si l'image est au centre
        if (answered) return; // Ne pas interagir deux fois
        answered = true;
        let isCorrect = false;
        //  Niveau débutant
        if (this.scene.game.data.level === 0) {
          isCorrect = this.goodIndices[this.goodIndicesIndex] === index;
        } else {
          // Niveau expert
          isCorrect = this.goodIndices.includes(index);
        }

        if (isCorrect) {
          this.currentIndex += 1;
          this.goodIndicesIndex += 1;
          feedbackFrame.setFillStyle(Colors.Elmt.Green);

          feedbackFrame.setVisible(true);
          image.disableInteractive();
          imageReponse.bg.setTexture("bonne-rep-activite-1");
          imageReponse.txt.setText(
            this.scene.getText("Mission2", "bonneReponse")
          );

          //cacher images derriere
          this.scene.hideActivite();
          // on affiche la popup debriefing
          this.scene.addPopupDebrief(key);
          this.scene.interIcons[this.scene.currentIndex].setTexture(
            "icone_check_without_shadow"
          );
          scene.time.delayedCall(1000, () => {
            imageReponse.setAlpha(0);
            tagReponseImage.setAlpha(1);
          });
        } else {
          imageReponse.bg.setTexture("mauvaise-rep-activite-1");
          imageReponse.txt.setText(
            this.scene.getText("Mission2", "mauvaiseReponse")
          );
          feedbackFrame.setFillStyle(Colors.Elmt.Red);

          feedbackFrame.setVisible(true);
          scene.time.delayedCall(1000, () => {
            feedbackFrame.setAlpha(0);
            feedbackFrame.setVisible(false);
            answered = false;
          });
        }
        // ✅ Préparation commune

        if (isCorrect) {
          feedbackFrame.setFillStyle(Colors.Elmt.Green);

          imageReponse.bg.setTexture("bonne-rep-activite-1");
          this.scene.getText("Mission2", "bonneReponse");
          image.disableInteractive();
          if (this.scene.sound && this.scene.sound.stopAll) {
            this.scene.sound.stopAll();
          }
        } else {
          feedbackFrame.setFillStyle(Colors.Elmt.Red);
          this.scene.getText("Mission2", "mauvaiseReponse");
          imageReponse.bg.setTexture("mauvaise-rep-activite-1");

          // Revenir à l'état initial après 1s
          scene.time.delayedCall(1000, () => {
            feedbackFrame.setAlpha(0);
            feedbackFrame.setVisible(false);
            imageReponse.setAlpha(0);
            imageReponse.setScale(0);
            imageReponse.setVisible(false);
            answered = false;
          });
        }

        // ✅ Animation simultanée
        this.scene.tweens.add({
          targets: feedbackFrame,
          alpha: 1,
          duration: 300,
          ease: "Sine.easeInOut",
        });
        this.scene.tweens.add({
          targets: imageReponse,
          alpha: 1,
          scale: 1,
          duration: 300,
          ease: "Back.easeOut", // tu peux utiliser Back.Out ici aussi
        });
      });
    });

    // Flèches
    const arrowOffsetX = spacing;
    const leftArrow = scene.add
      .image(-arrowOffsetX + 300, 0, "fleche-activite-1")
      .setScale(1.5)
      .setOrigin(0.5)
      .setInteractive({ cursor: "pointer" })
      .on("pointerdown", () => this.moveTo(this.currentIndex - 1));
    leftArrow.setAngle(180);
    this.add(leftArrow);

    const rightArrow = scene.add
      .image(arrowOffsetX - 300, 0, "fleche-activite-1")
      .setOrigin(0.5)
      .setScale(1.5)
      .setInteractive({ cursor: "pointer" })
      .on("pointerdown", () => this.moveTo(this.currentIndex + 1));
    this.add(rightArrow);

    this.updateSlider(); // Initial render
    scene.add.existing(this);
  }

  moveTo(index) {
    if (index < 0 || index >= this.slides.length) return;
    this.currentIndex = index;
    this.updateSlider();
  }

  updateSlider() {
    const centerX = 0; // Le centre de ce Container (x=0)

    this.slides.forEach((container, i) => {
      const relativeIndex = i - this.currentIndex;

      const targetX = relativeIndex * this.spacing;

      const scale = i === this.currentIndex ? this.upperScale : this.baseScale;

      this.scene.tweens.add({
        targets: container,
        x: targetX,
        scale,
        duration: 400,
        ease: "Sine.easeInOut",
      });
    });
  }
}
